export default "__VITE_ASSET__CTWLr7Oa__"